import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {LoginComponent} from './login.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import { GrowlerModule } from '../core/growler/growler.module';
import { SharedModule } from '../shared/shared.module';
import { SettingsService, CustomAuthService } from '../shared/services';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    GrowlerModule,
    SharedModule,
    TranslateModule
  ],
  exports: [LoginComponent],
  providers: [
    SettingsService,
    CustomAuthService
  ],
  declarations: [LoginComponent]
})
export class LoginModule {
  static getRoutes() {
    return [
      {path: 'login', component: LoginComponent}
    ];
  }
}
